import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { connect } from 'react-redux';
import FlechaIzquierda from '../validation/arrowLeft.svg';
import {
  IconButton,
  Checkbox,
  Typography,
  Fade,
  Button,
  Modal,
  withStyles,
  Backdrop,
  Divider
} from '@material-ui/core';
import StepBullets from '../StepBullets';
import iconModal from '../../agent/Tabs/Payments/img/iconModal.png';
import { ArrowBack, Menu as MenuIcon, InboxOutlined, ExpandMore, ExpandLess } from '@material-ui/icons';
import { useHistory, useLocation } from 'react-router-dom';
import { compose } from 'redux';
import PolicyDetails from './PolicyDetails';
import DomiciliationContainer from './DomiciliationContainer';
import PolicyReceiptsList from './PolicyReceiptsList';
import PaymentSummary from './PaymentSummary';
import PaymentConfirmationModal from './PaymentConfirmationModal';
import PolicyReceiptsHeader from './PolicyReceiptsHeader';
import { paymentRequestAgent, recurringPaymentRequestAgent } from '../../../redux/actions/agentActions';
import {
  persistDataPolicy,
  getClientsRFC,
  validateTokenClientMobile,
  clearReceipts
} from '../../../redux/actions/clientActions';
import Spinner from '../Spinner';
import { isMobile } from 'react-device-detect';
import ChangePaymentMethodAction from '../../agent/Tabs/Payments/changePaymentMethodAction';
import MessageSuccessDomiciliation from '../../agent/Tabs/Payments/MessageSuccessDomiciliation';
import moment from 'moment';

const catalogErrors = {
  'The currency of a receipt does not correspond.': 'La moneda de un recibo no corresponde.',
  'Receipts does not exist.': 'Los recibos no existen.',
  'Some receipts does not exists.': 'Algunos recibos no existen.',
  'Some receipts is already paid.': 'Algunos recibos ya fueron pagados.',
  'Some receipts is already canceled.': 'Algunos recibos ya fueron cancelados.',
  'Some receipts have expired.': 'Algunos recibos han expirado.',
  'The total of some receipts does not correspond to the total.':
    'El total de algunos recibos no corresponde al total.',
  'You cannot pay a domicilied policy.':
    'El recibo de la póliza seleccionada se encuentra domiciliado. Para poder realizar el cobro en línea es necesario desactivar dicha domiciliación y evitar duplicidad de cobro por el proceso automático.',
  'You can not pay a domicilied policy.':
    'El recibo de la póliza seleccionada se encuentra domiciliado. Para poder realizar el cobro en línea es necesario desactivar dicha domiciliación y evitar duplicidad de cobro por el proceso automático.',
  'Unauthorized. JWT invalid.': 'El token de autenticación no es válido.',
  'JWT duplicated': 'El token de autenticación no es válido.',
  'Register not found' : 'La póliza no existe.',
  'Receipt not found' : 'El recibo no existe.',
  'RFC is not correct' : 'El RFC es inválido.',
  'No pending receipts found' : 'No hay recibos pendientes de pago en este momento.'
};

const getErrorMessage = errorMessage => {
  if (catalogErrors[errorMessage]) {
    return catalogErrors[errorMessage];
  }

  const dynamicErrorPatterns = [
    {
      pattern: /^Session active with policy id \d+, product id \d+, office id \d+ and rfc [A-Z0-9]+\.?$/i,
      useOriginal: false,
      translation: 'Ya existe una sesión activa para esta póliza.'
    },
    {
      pattern: /^No se puede pagar la factura \d+ porque la factura anterior \d+ no ha sido pagada$/,
      useOriginal: true
    }
  ];

  for (const errorPattern of dynamicErrorPatterns) {
    if (errorPattern.pattern.test(errorMessage)) {
      return errorPattern.useOriginal ? errorMessage : errorPattern.translation;
    }
  }

  return 'La página no se encuentra disponible. Inténtelo más tarde.';
};

const drawerWidth = 240;
const styles = theme => ({
  menuButton: {
    marginRight: 20,
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    }
  },
  buttonPrimary: {
    width: '117px',
    height: '40px',
    background: '#0133A0',
    borderRadius: '20px',
    color: '#FFFFFF',
    fontFamily: 'Sura Sans',
    fontSize: '14px'
  },
  buttonSecondary: {
    width: '117px',
    height: '40px',
    background: '#E3E828',
    borderRadius: '20px',
    color: '#0133A0',
    fontFamily: 'Sura Sans',
    fontSize: '14px'
  },
  modal: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '391px',
    height: '303px',
    backgroundColor: '#FFF',
    borderRadius: '10px',
    padding: '8px 30px',
    boxShadow: theme.shadows[5],
    outline: 'none',
    marginTop: '20%'
  },
  toolbar: theme.mixins.toolbar,
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
      position: 'relative'
    }
  },
  amountDivider: {
    backgroundColor: '#FFFFFF',
    width: '100%',
    margin: '5px 0'
  }
});

function PolicyScreen({
  receipts,
  clientToken,
  catalog,
  currency,
  classes,
  paymentRequestAgent,
  recurringPaymentRequestAgent,
  identificate,
  persistDataPolicy,
  getClientsRFC,
  validateTokenClientMobile,
  clearReceipts,
  errorPaymentRequest
}) {
  const history = useHistory();
  const location = useLocation();
  const policyFromParams = useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    return {
      policy: queryParams.get('policy'),
      office_id: queryParams.get('office_id'),
      product_id: queryParams.get('product_id'),
      event: queryParams.get('event'),
      receipt: queryParams.get('receipt'),
      nextDate: queryParams.get('nextDate'),
      rfc: queryParams.get('rfc'),
      client_mobile: queryParams.get('client_mobile')
    };
  }, [location.search]);

  const [openModal, setOpenModal] = useState(false);
  const [showDetails, setShowDetails] = useState({});
  const [selectedReceipts, setSelectedReceipts] = useState([]);
  const [errorMessages, setErrorMessages] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const isProcessingRef = useRef(false);
  const [showToast, setShowToast] = useState(false);
  const [showDomiciliationMessage, setShowDomiciliationMessage] = useState(false);
  const isValid = true;
  const [expandedDetails, setExpandedDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(false);
  const [isMobileClientFlow, setIsMobileClientFlow] = useState(false);
  const [mobileClientData, setMobileClientData] = useState(null);
  const [mobileClientToken, setMobileClientToken] = useState(null);
  const lastLoadedKeyRef = useRef(null);
  const currentLoadKey = useMemo(() => {
    return [
      policyFromParams.policy || '',
      policyFromParams.office_id || '',
      policyFromParams.product_id || '',
      policyFromParams.rfc || '',
      policyFromParams.event || ''
    ].join('|');
  }, [
    policyFromParams.policy,
    policyFromParams.office_id,
    policyFromParams.product_id,
    policyFromParams.rfc,
    policyFromParams.event
  ]);

  // Cleanup receipts when component unmounts
  useEffect(() => {
    return () => {
      clearReceipts();
    };
  }, [clearReceipts]);

  // SSO Client Portal
  const getCurrentToken = useCallback(() => {
    return isMobileClientFlow && mobileClientToken ? mobileClientToken : clientToken;
  }, [isMobileClientFlow, mobileClientToken, clientToken]);

  const handleMobileClientFlow = useCallback(
    async clientMobileToken => {
      try {
        setIsLoading(true);
        setIsInitialLoading(true);

        const response = await validateTokenClientMobile(clientMobileToken);

        if (response.code === 200) {
          if (response.data && response.data.paymentLink) {
            window.location.href = response.data.paymentLink;
            return;
          } else if (response.data && Array.isArray(response.data)) {
            setIsMobileClientFlow(true);
            setMobileClientData(response);
            setMobileClientToken(response.session && response.session.access_token);
            setHasLoaded(true);

            setTimeout(() => {
              history.replace(location.pathname);
            }, 500);

            return;
          }
        }

        throw new Error('Respuesta inesperada del servidor');
      } catch (error) {
        console.error('Error en flujo de cliente móvil:', error);

        const errorData = error.response && error.response.data;
        if (errorData && errorData.code >= 400) {
          setMobileClientData({ error: errorData });
          setShowToast(true);
          setTimeout(() => setShowToast(false), 8000);

          setTimeout(() => {
            history.replace(location.pathname);
          }, 500);
        }
      } finally {
        setIsLoading(false);
        setIsInitialLoading(false);
      }
    },
    [validateTokenClientMobile, history, location.pathname]
  );

  const getFreshTokenForQueryFlow = useCallback(async () => {
    if (isMobileClientFlow) {
      return true;
    }
    return clientToken;
  }, [isMobileClientFlow, clientToken]);

  // Load receipts after recurring payment
  const loadPolicyFromParams = useCallback(async () => {
    const shouldForceReload = policyFromParams.event === 'payment_successful';
    const shouldLoad =
      policyFromParams.policy &&
      policyFromParams.office_id &&
      policyFromParams.product_id &&
      (!hasLoaded || shouldForceReload);

    if (shouldLoad) {
      setIsLoading(true);
      setIsInitialLoading(true);

      try {
        const effectiveToken = await getFreshTokenForQueryFlow();

        await clearReceipts();

        const sanitizedDataBase = {
          poliza: policyFromParams.policy ? parseInt(policyFromParams.policy, 10).toString() : '',
          oficina: policyFromParams.office_id ? parseInt(policyFromParams.office_id, 10).toString() : '',
          ramo: policyFromParams.product_id ? parseInt(policyFromParams.product_id, 10).toString() : ''
        };

        await getClientsRFC(effectiveToken, sanitizedDataBase, true);

        if (policyFromParams.rfc) {
          // Wait for the backend to update recurring payment in database
          await new Promise(resolve => setTimeout(resolve, 2600));
          await getClientsRFC(effectiveToken, { ...sanitizedDataBase, rfc: policyFromParams.rfc }, true);
        }

        persistDataPolicy({
          rfc: policyFromParams.rfc,
          poliza: policyFromParams.policy,
          oficina: policyFromParams.office_id,
          ramo: policyFromParams.product_id
        });

        setHasLoaded(true);
        setIsInitialLoading(false);
      } catch (error) {
        console.error('Error al cargar la póliza:', error);
        if (error.response && error.response.status === 401) {
          console.warn('Error de autenticación, redirigiendo al flujo normal');
          history.push('/cobranza/identificate');
        }
        setIsInitialLoading(false);
      } finally {
        setIsLoading(false);
      }
    }
  }, [
    policyFromParams.policy,
    policyFromParams.office_id,
    policyFromParams.product_id,
    policyFromParams.rfc,
    policyFromParams.event,
    hasLoaded,
    getClientsRFC,
    persistDataPolicy,
    clearReceipts,
    getFreshTokenForQueryFlow,
    history
  ]);

  useEffect(() => {
    // Init mobile client SSO
    if (policyFromParams.client_mobile && !isMobileClientFlow && !hasLoaded) {
      handleMobileClientFlow(policyFromParams.client_mobile);
      return;
    }

    // Init authentification with params
    if (policyFromParams.policy && policyFromParams.office_id && policyFromParams.product_id) {
      if (lastLoadedKeyRef.current !== currentLoadKey) {
        lastLoadedKeyRef.current = currentLoadKey;
        loadPolicyFromParams();
      }
    }

    // Successful payment request message
    if (policyFromParams.event === 'payment_successful') {
      setShowDomiciliationMessage(true);
      setTimeout(() => {
        history.replace(location.pathname);
      }, 3000);
      setTimeout(() => {
        setShowDomiciliationMessage(false);
      }, 30000);
    }
  }, [
    policyFromParams.client_mobile,
    policyFromParams.policy,
    policyFromParams.office_id,
    policyFromParams.product_id,
    policyFromParams.event,
    isMobileClientFlow,
    hasLoaded,
    handleMobileClientFlow,
    currentLoadKey,
    loadPolicyFromParams,
    history,
    location.pathname
  ]);

  const toggleDetails = policyId => {
    setExpandedDetails(prev => ({
      ...prev,
      [policyId]: !prev[policyId]
    }));
  };

  const handleReceiptSelection = (uuid, identifier, orderedInvoices, receipt, currency, policyId, typePolicy, policyMasterId) => {
    const currentIndex = orderedInvoices.findIndex(invoice => invoice.identifier.toString() === identifier.toString());
    if (currentIndex === -1) return;

    const exists = selectedReceipts.some(item => item.uuid === uuid);

    if (!exists) {
      const isValidSelection = orderedInvoices
        .slice(0, currentIndex)
        .every(invoice => selectedReceipts.some(item => item.uuid === invoice.uuid));

      if (!isValidSelection) {
        setErrorMessages(prev => ({
          ...prev,
          [uuid]: 'Este recibo no puede ser agregado debido a que existen pendientes'
        }));
        return;
      }

      setErrorMessages(prev => ({ ...prev, [uuid]: '' }));

      setSelectedReceipts(prev => [
        ...prev,
        {
          uuid,
          receipt,
          invoice: receipt.invoice,
          total: receipt.total,
          currency,
          policyId,
          typePolicy,
          policyMasterId
        }
      ]);
    } else {
      const updatedReceipts = selectedReceipts.filter(item => {
        const index = orderedInvoices.findIndex(invoice => invoice.uuid === item.uuid);
        return index < currentIndex;
      });

      setSelectedReceipts(updatedReceipts);
    }
  };

  const handleBackClick = () => {
    if (identificate) {
      history.push('/cobranza/identificate');
    } else {
      history.push('/cobranza/validacion');
    }
  };
  const handleSearch = () => {
    if (selectedReceipts.length === 0) {
      setErrorMessages(prev => ({
        ...prev,
        global: 'Debes seleccionar al menos un recibo para continuar.'
      }));
      return;
    }
    setErrorMessages(prev => ({ ...prev, global: '' }));
  };

  const handleExpandClick = () => {
    history.push(`/cobranza/cliente`);
  };
  const [checked, setChecked] = useState(false);
  const [expandedPolicies, setExpandedPolicies] = useState({});

  const hasUSD = selectedReceipts.every(item => item.currency === 'USD');
  const calculateTotalSum = () => {
    const totalSum = selectedReceipts.reduce((sum, receipt) => {
      let total;

      if (hasUSD && !checked) {
        total = receipt.total;
      } else if (hasUSD && checked) {
        total = receipt.total * currency;
      } else {
        total = receipt.currency === 'USD' ? receipt.total * currency : receipt.total;
      }
      return sum + total;
    }, 0);
    return totalSum.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const policyData = selectedReceipts.reduce((acc, receipt) => {
    if (!acc[receipt.policyId]) {
      acc[receipt.policyId] = {
        solution: receipt.typePolicy,
        receipts: [],
        policyMasterId: receipt.policyMasterId || null
      };
    }
    acc[receipt.policyId].receipts.push(receipt);
    return acc;
  }, {});

  const handleToggle = () => setChecked(!checked);

  const toggleExpand = policyId => {
    setExpandedPolicies(prev => ({
      ...prev,
      [policyId]: !prev[policyId]
    }));
  };
  const handleCloseModal = () => {
    setOpenModal(false);
    setLoading(false)
  };

  const handleModalConfirm = async () => {
    if (isProcessingRef.current) {
      return;
    }
    if (loadingPayment || isProcessingPayment) {
      return;
    }
    isProcessingRef.current = true;
    setOpenModal(false);
    setLoadingPayment(true);
    setIsProcessingPayment(true);
    try {
      await handlePaymentRequestUSD();
    } catch (error) {
      console.error('Error en pago USD:', error);
      setLoadingPayment(false);
      setIsProcessingPayment(false);
      isProcessingRef.current = false;
    }
  };
  const handlePaymentRequestMXN = async () => {
    try {
      let json = {
        receipts: selectedReceipts.map(row => ({
          uuid: row.uuid,
          amount: parseFloat(row.total),
          currency_rate: ['MXP', 'MXN'].includes(row.currency) ? 1 : Number(currency)
        })),
        // Include token for backend to verify domiciliation permissions
        token: getCurrentToken()
      };

      await paymentRequestAgent(getCurrentToken(), json);
      persistDataPolicy(formData);
      setShowToast(true);

      setTimeout(() => {
        setShowToast(false);
      }, 3000);
    } catch (error) {
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
      }, 5000);
      setLoadingPayment(false);
      setIsProcessingPayment(false);
      isProcessingRef.current = false;
    }
  };

  const handlePaymentRequestUSD = async () => {
    try {
      let json = {
        exchange_rate: {
          total_receipts: Number(calculateTotalSum()),
          currency_rate: Number(currency)
        },
        receipts: selectedReceipts.map(row => ({
          uuid: row.uuid,
          amount: parseFloat(row.total),
          currency_rate: ['MXP', 'MXN'].includes(row.currency) ? 1 : Number(currency)
        })),
        // Include token for backend to verify domiciliation permissions
        token: getCurrentToken()
      };
      await paymentRequestAgent(getCurrentToken(), json);
      persistDataPolicy(formData);
      setShowToast(true);

      setTimeout(() => {
        setShowToast(false);
      }, 3000);
    } catch (error) {
      setLoadingPayment(false);
      setIsProcessingPayment(false);
      isProcessingRef.current = false;
      throw error;
    }
  };
  const handlePaymentRequest = async () => {
    if (isProcessingRef.current) {
      return;
    }
    if (loadingPayment || isProcessingPayment) {
      return;
    }
    isProcessingRef.current = true;
    setLoadingPayment(true);
    setIsProcessingPayment(true);
    try {
      if (hasUSD) {
        if (checked) {
          await handlePaymentRequestMXN();
        } else {
          setOpenModal(true);
          setLoadingPayment(false);
          setIsProcessingPayment(false);
          isProcessingRef.current = false;
        }
      } else {
        await handlePaymentRequestMXN();
      }
    } catch (error) {
      console.error('Error en handlePaymentRequest:', error);
      setLoadingPayment(false);
      setIsProcessingPayment(false);
      isProcessingRef.current = false;
    }
  };
  const handleToggleSelectAll = (orderedInvoices, policyId, policyReceipts, policyDetails, typePolicy, policyMasterId) => {
    let errors = {};
    let updatedSelectedReceipts = [...selectedReceipts];
    const validReceipts = policyReceipts.filter(receipt =>
      orderedInvoices.some(invoice => invoice.identifier === receipt.invoice)
    );

    for (let i = 0; i < validReceipts.length; i++) {
      const receipt = validReceipts[i];
      const currentIndex = orderedInvoices.findIndex(
        invoice => invoice.identifier.toString() === receipt.invoice.toString()
      );

      const exists = updatedSelectedReceipts.some(item => item.uuid === receipt.uuid);

      if (!exists) {
        const isValidSelection = orderedInvoices
          .slice(0, currentIndex)
          .every(invoice => updatedSelectedReceipts.some(item => item.uuid === invoice.uuid));

        if (!isValidSelection) {
          errors[receipt.uuid] = 'Este recibo no puede ser agregado debido a que existen pendientes';
          break;
        }

        updatedSelectedReceipts = [
          ...updatedSelectedReceipts,
          {
            uuid: receipt.uuid,
            receipt: receipt.receipt,
            invoice: receipt.invoice,
            total: receipt.total,
            currency: policyDetails.currency,
            policyId,
            typePolicy: typePolicy,
            policyMasterId
          }
        ];
      }
    }

    if (Object.keys(errors).length > 0) {
      setErrorMessages(prev => ({ ...prev, ...errors }));
    } else {
      setSelectedReceipts(updatedSelectedReceipts);
      setErrorMessages({});
    }
  };
  const handleToggleDeselectAll = orderedInvoices => {
    setSelectedReceipts(prev => prev.filter(item => !orderedInvoices.some(invoice => invoice.uuid === item.uuid)));
    setErrorMessages({});
  };

  return (
    <div
      style={{
        display: 'flex',
        width: '100vw',
        maxWidth: '1440px',
        margin: '0 auto',
        padding: isMobile ? '100px 6% 60px' : '60px 150px 100px 80px',
        flexDirection: isMobile ? 'column' : 'row'
      }}
    >
      {showToast && (errorPaymentRequest || (mobileClientData && mobileClientData.error)) && (
        <div
          className="toast"
          style={{
            visibility: 'visible',
            minWidth: isMobile ? '90%' : '800px',
            backgroundColor: '#F4C7C7',
            color: 'red',
            textAlign: 'center',
            borderRadius: '10px',
            padding: '16px',
            position: 'fixed',
            zIndex: 1000,
            left: '50%',
            bottom: '60px',
            fontSize: '17px',
            opacity: 1,
            transition: 'opacity 0.6s, visibility 0.6s',
            border: '1px solid red',
            transform: 'translateX(-50%)'
          }}
        >
          {(() => {
            if (mobileClientData && mobileClientData.error) {
              const errorMessage =
                mobileClientData.error.error || mobileClientData.error.message || mobileClientData.error;
              console.log('Error message extracted:', errorMessage);
              const mappedMessage = getErrorMessage(errorMessage);
              console.log('Mapped message:', mappedMessage);
              return mappedMessage;
            }
            return getErrorMessage(errorPaymentRequest);
          })()}
        </div>
      )}
      {showDomiciliationMessage && (
        <MessageSuccessDomiciliation
          onClose={() => setShowDomiciliationMessage(false)}
          receiptNumber={policyFromParams.receipt}
          nextDate={policyFromParams.nextDate}
        />
      )}
      <div
        style={{
          display: 'flex',
          width: isMobile ? '100%' : 'calc(100% - 264px)',
          flexDirection: 'column'
        }}
      >
        <PolicyReceiptsHeader
          identificate={identificate}
          onBackClick={handleBackClick}
          FlechaIzquierda={FlechaIzquierda}
          StepBullets={StepBullets}
        />
        <PolicyReceiptsList
          currentReceipts={isMobileClientFlow && mobileClientData ? mobileClientData : receipts}
          currency={currency}
          expandedDetails={expandedDetails}
          selectedReceipts={selectedReceipts}
          errorMessages={errorMessages}
          toggleDetails={toggleDetails}
          handleReceiptSelection={handleReceiptSelection}
          handleToggleSelectAll={handleToggleSelectAll}
          handleToggleDeselectAll={handleToggleDeselectAll}
          getCurrentToken={getCurrentToken}
          clientToken={getCurrentToken()}
          recurringPaymentRequestAgent={recurringPaymentRequestAgent}
          PolicyDetails={PolicyDetails}
          DomiciliationContainer={DomiciliationContainer}
          ChangePaymentMethodAction={ChangePaymentMethodAction}
          classes={classes}
          history={history}
          isInitialLoading={isInitialLoading}
          Spinner={Spinner}
        />
      </div>
      <PaymentSummary
        selectedReceipts={selectedReceipts}
        currency={currency}
        policyData={policyData}
        checked={checked}
        expandedPolicies={expandedPolicies}
        loadingPayment={loadingPayment}
        isProcessingPayment={isProcessingPayment}
        calculateTotalSum={calculateTotalSum}
        handleToggle={handleToggle}
        toggleExpand={toggleExpand}
        handlePaymentRequest={handlePaymentRequest}
        Spinner={Spinner}
        classes={classes}
      />
      <PaymentConfirmationModal
        open={openModal}
        loadingPayment={loadingPayment}
        isProcessingPayment={isProcessingPayment}
        onClose={handleCloseModal}
        onConfirm={handleModalConfirm}
        iconModal={iconModal}
        Backdrop={Backdrop}
        classes={classes}
      />
    </div>
  );
}

const mapStateToProps = state => ({
  clientToken: state.clientReducer.clientToken,
  catalog: state.clientReducer.catalog,
  receipts: state.clientReducer.receipts,
  currency: state.agentReducer.currency,
  identificate: state.clientReducer.identificate,
  errorPaymentRequest: state.agentReducer.errorPaymentRequest
});

const mapDispatchToProps = {
  paymentRequestAgent,
  recurringPaymentRequestAgent,
  persistDataPolicy,
  getClientsRFC,
  validateTokenClientMobile,
  clearReceipts
};
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles, { withTheme: true })
)(PolicyScreen);



// WEBPACK FOOTER //
// ./src/containers/client/receipts/index.js